<template>
  <div>
    <span class="title" v-if="showTitle">{{ titleContent }}</span>
    {{ message }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    type: {
      type: String,
      default: 'success',
    },
    title: {
      type: [String, Boolean],
      default: undefined,
    },
    message: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    showTitle() {
      // return (this.title === false || this.title === null) ? false : true; // undefined => show default
      return (this.title === false || this.title === null || this.title === undefined) ? false : true;
    },
    titleContent() {
      // if (this.title === undefined) return this.$t(`engine.common.alert.${this.type}.title`, 'en');
      return this.title;
    }
  },
}
</script>
